var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("autocomplete", {
        attrs: {
          search: _vm.search,
          placeholder: "Введите фразу",
          "aria-label": "Введите фразу",
          "get-result-value": _vm.getResultValue,
        },
        on: { submit: _vm.handleSubmit },
        scopedSlots: _vm._u([
          {
            key: "result",
            fn: function (ref) {
              var result = ref.result
              var props = ref.props
              return [
                _c(
                  "li",
                  _vm._b(
                    { staticClass: "autocomplete-result search-result" },
                    "li",
                    props,
                    false
                  ),
                  [
                    _c("div", { staticClass: "search-result-title" }, [
                      _vm._v("\n\t\t\t\t\t" + _vm._s(result.name) + " "),
                      _c("span", { class: result.badgeCssClass }, [
                        _vm._v(_vm._s(result.type)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "search-result-snippet",
                      domProps: { innerHTML: _vm._s(result.snippet) },
                    }),
                  ]
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }